import React from "react";
import Modal from "react-modal";
import GallerySlider from "../components/gallery-slider";

Modal.setAppElement("#___gatsby");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#E19C67",
    padding: "10px"
  }
};

const Gallery = ({ gallery }) => {

  const addContent = () => {
    return (
      <>
        <ul className="gallery-list">
          {
            gallery.map((item) => (
              <li
                className="gallery-item"
                key={item.id}
              >
                <div
                  className="gallery-item-inner"
                  role = "button"
                  onClick={openModal}
                  onKeyDown={openModal}
                  tabIndex={0}
                >
                  <img src={item.src} alt={item.alt} title={item.alt} width="530px"/>
                </div>
              </li>
            ))
          }
        </ul>
      </>
    );
  };

  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <div>
      {addContent()}
      <Modal
        isOpen={modalIsOpen}
        style={customStyles}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
      >
        <button onClick={closeModal} className="modal-close" aria-label="close modal"><i
          className="fa fa-window-close" /></button>
        <GallerySlider gallery={gallery} />
      </Modal>
    </div>
  );

};

export default Gallery;